import { AnnouncementLookupResolveService } from './shared/services/announcement-lookup-resolve.service';
import { AnnouncementService } from './shared/services/announcement.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnnouncementsRoutingModule } from './announcements-routing.module';
import { AnnouncementShellComponent } from './announcement-shell/announcement-shell.component';
import { AnnouncementListComponent } from './announcement-list/announcement-list.component';
import { SharedModule } from '@admin/shared/shared.module';
import { AnnouncementDetailsComponent } from './announcement-details/announcement-details.component';
import { FutureAnnouncementsComponent } from './future-announcements/future-announcements.component';
import { ModerationAnnouncementComponent } from './moderation-announcement/moderation-announcement.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AnnouncementInfoComponent } from './moderation-announcement/announcement-info/announcement-info.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AnnouncementsRoutingModule,
    AngularSvgIconModule,
  ],
  providers: [AnnouncementService, AnnouncementLookupResolveService],
  declarations: [
    AnnouncementShellComponent,
    AnnouncementListComponent,
    AnnouncementDetailsComponent,
    FutureAnnouncementsComponent,
    ModerationAnnouncementComponent,
    AnnouncementInfoComponent,
  ],
})
export class AnnouncementsModule {}
